import CategoriesItemLamps from "./CategoriesItemLamps.jsx";
import Footer from "../Footer.jsx";
import Newsletter from "../Newsletter.jsx";

function Lamps() {
  return (
    <>
      <CategoriesItemLamps />
      <Newsletter />
      <Footer />
    </>
  );
}

export default Lamps;
